import { useCallback, useState } from 'react'

function useToggle(initial) {
  const [value, setValue] = useState(initial)
  const toggleFn = useCallback(() => setValue(!value), [value])

  return [value, toggleFn]
}
export default useToggle
